// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"120e27ef","356":"682e420f","438":"9184919e","465":"ee3d574d","538":"120c7232","912":"4bf5a352","954":"5561c953"}[chunkId] + ".chunk.js";
};